import { makeStyles } from "@/compat/muiStyles";
import BrandingLogo from "./BrandingLogo";
import type { BrandingDTO } from "../../types/brandingDtos";

const useStyles = makeStyles(() => ({
    logo: { display: "flex", justifyContent: "flex-end" },
}));

interface RiskAssessmentBrandingProps {
    branding?: BrandingDTO | null;
}

export function BrandingMark({ branding }: RiskAssessmentBrandingProps) {
    const classes = useStyles();

    if (!branding?.logoReference) return null;

    return (
        <div className={classes.logo}>
            <BrandingLogo reference={branding.logoReference} fileName={branding.logoFileName} />
        </div>
    );
}
